export const email = (text) => (/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/).test(text);

export const leftPadZero = (num, width) => num.toString().padStart(width, 0);
